import React, { useCallback } from 'react'
import { FilteredPropertyData } from '../../../types/PropertyData'
import { useSelectpicker } from '../../utils/useSelectpicker'

export type DropDownProps = {
  propertyData: FilteredPropertyData
  value?: string
  setValue?: (nextValue: string) => void
  className?: string
}

const DropDown: React.FC<DropDownProps> = ({ propertyData, value, setValue }) => {
  const handleChange = useCallback<React.ChangeEventHandler<HTMLSelectElement>>(
    (e) => {
      setValue?.(e.target.value)
    },
    [setValue]
  )
  const selectElement = useSelectpicker()

  return (
    <div>
      {propertyData.displayName}
      <select value={value} onChange={handleChange} ref={selectElement}>
        {propertyData.values
          .filter((x) => !x.disabled)
          .map((x) => (
            <option key={x.id} value={x.id}>
              {x.displayName}
            </option>
          ))}
      </select>
    </div>
  )
}

export default DropDown
